<template>
  <div class="container">
  </div>
</template>

<script>
  import mobileType from '../../utils/mobileType';

  export default {
    data() {
      return {
        data: {}
      };
    },
    created() {
      //Vue的方法给原生调用，则需要把方法挂在Window下面
      window.getDataFromNative = this.getDataFromNative;
    },
    mounted() {
      this.openMiniProgram();
    },
    methods: {
      openMiniProgram() {
        let params = {
          type: 2,//业务类型(固定跳转微信小程序)
          data: {
            title: '代驾跳转小程序',
            userName: 'gh_abcc55f26797',
            path: 'pages/index/index',
            miniprogramType: process.env.VUE_APP_CURRENTMODE == 'prod' ? 0 : 2,//  正式：0、开发版：1、体验版：2
          },//传多个参数给原生(为对象类型)
        };
        if (mobileType.isIOS()) {
          //vue调用iOS方法，且传值给iOS （iOS 方法名为 getDataFromVue）
          window.webkit.messageHandlers.getDataFromVue.postMessage(params);
        } else if (mobileType.isAndroid()) {
          //vue调用Android方法，且传值给Android （Android方法名为 getDataFromVue）
          window.Android.getDataFromVue(JSON.stringify(params));
        } else {
        }
      },
    },
  };
</script>
<style scoped lang="less">
</style>

